// extracted by mini-css-extract-plugin
export default {"card":"TrapImagesViewerComponent_card__HKSd0","buttons":"TrapImagesViewerComponent_buttons__JAwjl"};